import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import { api, formatApiError } from "../lib/api";

export default function Article() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.get(`/articles/${slug}`).then(({ data }) => setData(data)).catch((e) => setErr(formatApiError(e)));
  }, [slug]);

  if (err) {
    return (
      <div className="min-h-screen bg-[#FAFAFA]">
        <Header />
        <section className="px-6 py-32 max-w-2xl mx-auto text-center">
          <p className="overline text-[#8B6D5E] mb-4">— Artículo no encontrado</p>
          <Link to="/journal" className="overline link-underline">← Volver al Journal</Link>
        </section>
        <Footer />
      </div>
    );
  }
  if (!data) return null;

  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="article-page">
      <Helmet>
        <title>{`${data.title} — The Journal · Abril Suarez`}</title>
        <meta name="description" content={data.excerpt} />
      </Helmet>
      <Header />

      <section className="px-6 sm:px-10 pt-28 pb-8 max-w-3xl mx-auto">
        <Link to="/journal" className="overline link-underline text-[#8B6D5E]">← The Journal</Link>
        <p className="overline text-[#8B6D5E] mt-8 mb-4">
          {data.category} · Lectura {data.reading_time} min
        </p>
        <h1 className="font-serif text-5xl sm:text-6xl leading-[1.02] mb-6">{data.title}</h1>
        <p className="text-lg text-[#5C5C5C]">
          {new Date(data.published_at).toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric" })} · por Abril Suarez
        </p>
      </section>

      {data.cover_image && (
        <div className="max-w-5xl mx-auto px-6 sm:px-10">
          <img src={data.cover_image} alt={data.title} className="w-full aspect-[16/9] object-cover" />
        </div>
      )}

      <article className="px-6 sm:px-10 py-16 max-w-2xl mx-auto">
        {data.body.split("\n\n").map((p, i) => (
          <p key={i} className="font-serif text-lg sm:text-xl leading-relaxed text-[#1A1A1A] mb-6" data-testid={`article-p-${i}`}>
            {p}
          </p>
        ))}
      </article>

      <section className="px-6 sm:px-10 py-24 bg-[#F7F0E8]">
        <div className="max-w-2xl mx-auto text-center">
          <p className="overline text-[#8B6D5E] mb-6">— Sigue leyendo</p>
          <Link to="/journal" className="font-serif text-3xl sm:text-4xl hover:text-[#8B6D5E] transition-colors">
            Más piezas en The Journal →
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
